import React from 'react'
import styles from './add-pupil-button.styles'
import injectSheet from 'react-jss'
import Button from 'pobble-components/dist/button'
import PlusIcon from 'react-icons/lib/fa/plus'
import { withRouter } from 'react-router-dom'

const AddPupilButton = ({
  classes,
  searchValue,
  searchValueChange,
  history,
  disabled
}) => (
  <Button
    disabled={disabled}
    tall
    action={() => {
      history.push('/add-pupils')
    }}>
    <PlusIcon className={classes.icon} />
    Add Pupils
  </Button>
)

export default withRouter(injectSheet(styles)(AddPupilButton))
